<!--
   Created by qing on 2020/1/21 9:29 下午
   Des: 散点图
-->
<template>
  <div
    v-if="value && value.xAxis && value.yAxis && value.series && value.series.length"
    class="statistics__scatter"
    ref="scatter">
  </div>
  <div
    v-else
    :key="emptyKey"
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
  import {clone, formatNum} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        emptyKey: Math.random(),
        optConf: {
          tooltip: {
            // trigger: 'axis',
            showDelay: 0
          },
          label: {
            show: true, // 显示图表标签
            position: 'top',
            formatter: '{b}'
          },
          itemStyle: {
            color: '#7CD6CF'
          },
          yAxis: {
            name: '',
            id: '',
            nameLocation: 'center',
            nameTextStyle : {
              padding: [0, 0, 20, 0]
            },
          },
          xAxis: {
            name: '',
            id: '',
            nameLocation: 'center',
            nameTextStyle : {
              padding: [20, 0, 0, 0]
            },
          },
          series: null, /*[

            {
              type: 'scatter',
              id: 'dataId',
              symbolSize: 20,
              data: [
               {
                 value: [13.0, 7.58],
                 name: '北京',
                 nameMap: {'订单地区':'北京','订单来源':'iOS','支付订单量':'13','好评':'7'},
                }
              ],
            }

          ]*/
        },
        chart: null,
        loaded: false,
      }
    },
    mounted() {
        if (this.$refs.scatter) {
          const chart = this.$ECharts.init(this.$refs.scatter)
          chart.title = ''
          this.chart = chart
          this.initChart()
        }

    },
    methods: {
      // 重新初始化图表 父级可调用
      initChart() {
        this.$nextTick(() => {
          if (!this.chart && this.$refs.scatter) {
            const chart = this.$ECharts.init(this.$refs.scatter)
            chart.title = ''
            this.chart = chart
          }
          if (this.value && this.chart) {
            const opt = clone(this.optConf)
            opt.color = this.showPropertiesHolder.theme.value
            const showFieldsColor = this.showPropertiesHolder.showFieldsColor
            const value = this.value
            if (value && value.xAxis && value.yAxis && value.series && value.series.length) {

              // Object.assign(opt.tooltip, this.current.toolTipsOpts) // 默认配置

              opt.tooltip.formatter = params => {
                let s = ''
                Object.keys(params.data.nameMap).forEach(item => {
                  s += item + ':' + formatNum(params.data.nameMap[item]) + '<br>'
                })
                return s
              }
              opt.xAxis.name = this.showPropertiesHolder.xAxisTitle ? this.showPropertiesHolder.xAxisTitle : value.xAxis.name
              opt.xAxis.id = value.xAxis.dataId
              opt.yAxis.name = this.showPropertiesHolder.yAxisTitle ? this.showPropertiesHolder.yAxisTitle : value.yAxis.name
              opt.yAxis.id = value.yAxis.dataId
              opt.series = {
                type: 'scatter',
                symbolSize: 20,
                data: value.series
              }

              opt.label.show = Boolean(this.showPropertiesHolder.showDataTag)

              // y轴最大值最小值
              if (this.showPropertiesHolder.yAxisMax.length) {
                opt.yAxis.max = Number(this.showPropertiesHolder.yAxisMax)
              }
              if (this.showPropertiesHolder.yAxisMin.length) {
                opt.yAxis.min = Number(this.showPropertiesHolder.yAxisMin)
              }

              // x轴label倾斜
              let axisLabel = {}
              if (this.showPropertiesHolder.xAxisDirection === 'left') {
                axisLabel = {
                  rotate: 30,
                }
              } else if (this.showPropertiesHolder.xAxisDirection === 'right') {
                axisLabel = {
                  rotate: -30,
                }
              }
              opt.xAxis.axisLabel = axisLabel

              if (!opt.series.data.length) {
                this.$toast.fail("没有数据")
                return
              }
              this.chart.setOption(opt, true, false, true)
              this.resize()
            } else {
              this.chart.clear()
              this.emptyKey = Math.random()
              this.chart = null
            }
            this.chart.on('click', params => {
              console.log('click',params)
              this.showDataDrillDownList(params)
            });
          }
        })
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      }
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .statistics__scatter {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
